import styled from 'styled-components';

// Atomes partagés par les deux cartes de la section facturation (Consommation & Facture potentielle) : même
// langage visuel, un seul endroit à toucher.

export const Card = styled.div`
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 12px;
    gap: 12px;
    flex-wrap: wrap;
`;

export const CardTitle = styled.h3`
    margin: 0;
    color: ${({ theme }) => theme.textColor};
    font-size: 16px;
    font-weight: 600;
`;

export const CardMeta = styled.span`
    color: ${({ theme }) => theme.ctaPrimaryTextColor};
    font-size: 13px;
`;

export const Muted = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.ctaPrimaryTextColor};
`;

export const BlockTitle = styled.div`
    font-weight: 600;
    color: ${({ theme }) => theme.textColor};
    margin-bottom: 4px;
`;

export const Amount = styled.span`
    padding: 2px 0;
    text-align: right;
    font-variant-numeric: tabular-nums;
`;
